import { useContext } from 'react';
import { CardContext } from '../../utils/cardContext';
import { Header } from '../../components/Building/parts/Header';

export const BuildingHeader = () => {
  const { displayName, reviewStats, specialStatusDisplay, url } = useContext(CardContext);

  return <Header title={displayName} rating={reviewStats} subtitle={specialStatusDisplay} url={url} />;
};
